module.exports = __webpack_public_path__ + "static/media/7.14.78a410f8.png";